import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from "../MaintenanceReportCategories";
import { Neo } from "@singularsystems/neo-react";
import { AppService, Types } from '../../../App/Services/AppService';
import { TextConstants } from "../../../Common/TextConstants";
import SecurityReconReportCriteria from './SecurityReconReportCriteria';

@NeoReport("SecurityRecon", { category: MaintenanceReportCategories.DataValidationReports })
export default class SecurityReconReport extends Report<SecurityReconReportCriteria> {
    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient)) {
        super(SecurityReconReportCriteria);
    }

    public renderCriteria() {
        return (
            <>
                <Neo.GridLayout lg={3}>
                    <Neo.FormGroup bindContext={this.criteria.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker}>
                        <Neo.AutoCompleteDropDown
                            itemSource={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                            bind={this.criteria.meta.staticServiceProviderFileGroupingId}
                            bindDisplay={this.criteria.meta.serviceProviderGroupingName}
                            displayMember={"serviceProviderGroupingName"}
                            items={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data.slice(0,10)
                                .sort((x, y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                        />
                    </Neo.FormGroup>
                    <Neo.FormGroup
                        appendText="fa-calendar"
                        bind={this.criteria.meta.date}
                    />
                </Neo.GridLayout>
            </>
        );
    }
}